import Vue from 'vue'
import Vuex from 'vuex'
import appStore from './AppStore'
import userStore from './UserStore'
import authStore from './AuthStore'
import timetableStore from '../components/Timetable/store/TimetableStore';
import passengerStore from '../components/Passenger/store/PassengerStore';
import destinationStore from '../components/Passenger/store/DestinationStore';
import rideStore from '../components/Timetable/store/RideStore';
import vuexI18n from 'vuex-i18n';
import createPersistedState from 'vuex-persistedstate'
import arrivalDepartureStore from '@/components/ArrivalsDepartures/store/ArrivalDepartureStore';
import bookingStore from '@/components/Booking/store/BookingStore';
import organizationStore from './OrganizationStore';
import importerStore from '@/components/Importer/store/ImporterStore';

const getLocalStorageKey = () => {
    return "timit-vuex-060-1";
}

Vue.use(Vuex)

const modules = {
    app: appStore as any,
    auth: authStore,
    user: userStore as any,
    timetable: timetableStore as any,
    ride: rideStore as any,
    passenger: passengerStore as any,
    destination: destinationStore as any,
    arrivalDeparture: arrivalDepartureStore as any,
    booking: bookingStore as any,
    organization: organizationStore as any,
    importer: importerStore as any,
}

const getPersistedPaths = (mods) => {
    let paths = [];
    Object.keys(mods).forEach((modName) => {
        const modPaths = mods[modName].persist;
        if (modPaths){
            paths = paths.concat(modPaths.map(p => modName + "." + p));
        }
    }) 
    return paths;
    // return [
    //     'user.showWeekends',
    //     'user.weekStartsOnSunday',
    //     'app.translateMode',
    //     'app.locale'
    // ] 
}

const store = new Vuex.Store({
    modules,
    plugins: [
        createPersistedState(
        {
            key: getLocalStorageKey(),
            paths: [
                ... getPersistedPaths(modules)
            ],
        }
    )]
})
export default store;

Vue.use(vuexI18n.plugin, store,
    {
        moduleName: 'i18n',
        async onTranslationNotFound(locale, key, def) {
            // TODO: Get rid of "any"
            const state = (store.state as any);
            if (state.i18n.translations.en) {
                console.warn(`i18n :: Key '${key}' not found for locale '${locale}'`);
                if (!state.i18n.translations.en[key]) {
                    console.warn("[Timit] i18n:", "Key '", key, " not found for English, adding it ...");
                    state.i18n.translations.en[key] = def;
                    await store.dispatch("i18n/replaceLocale", 
                    {
                        locale: "en",
                        translations: state.i18n.translations.en
                    });
                }
            }
        }
    }
);


